import { Inject, Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StorageService } from '../providers/storage.service';
import { SweetalertService } from '../providers/sweetalert.service';
import { STATE_CONFIG } from '../config/state.config';
import { StateConfig } from '../interfaces/state-config.interface';
import { EventCustom } from '../enum/event-custom.enum';
import { EventName } from '../enum/event-name.enum';
import { RoutePathMatch } from '../enum/route-path-match.enum';

@Injectable()
export class ResponseParseInterceptor implements HttpInterceptor {
    constructor(
        private sweetalertService: SweetalertService,
        private storageService: StorageService,
        @Inject(STATE_CONFIG) public stateConfig: StateConfig
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const request: any = req;

        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                switch (err.status) {
                    case 201:
                        return of(
                            new HttpResponse({
                                headers: err.headers,
                                status: 200,
                                statusText: err.statusText,
                                url: err?.url,
                                body: err.error.text,
                            })
                        );
                    case 401:
                        this.sweetalertService.unauthorized().then(() => {
                            this.storageService.clear();
                            this.stateConfig.set({
                                eventCustom: EventCustom.GLOBAL,
                                eventName: EventName.REDIRECTION,
                                data: { route: RoutePathMatch.LOGIN },
                            });
                        });
                        break;
                }
                return throwError(err);
            }),
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const body = event.body;
                    const modEvent: any = event.clone({
                        body:
                            body &&
                            Object.entries(body).filter(([k, _]) => k == 'data')
                                ?.length > 0
                                ? body.data
                                : body,
                    });
                    return modEvent;
                }
            })
        );
    }
}
